import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'
import Styles from './TemplateSelect.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Carousel } from 'components/Carousel/Carousel'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  width: number
  height: number
  itemWidth?: number
  itemHeight?: number
  categories?: number
  carouselOffset?: number
}

interface ShimmeringCategoryProps {
  width: number
  height: number
  itemWidth?: number
  itemHeight?: number
  carouselOffset?: number
}

const ShimmeringCategory = ({ width, height, itemWidth, itemHeight, carouselOffset }: ShimmeringCategoryProps) => {
  return (
    <div className={Styles.shimmeringCategory}>
      <div className={Styles.title} style={{ paddingLeft: carouselOffset }}>
        <Heading level={4}>
          <div className={Styles.shimmeringTitle} />
        </Heading>
      </div>

      <div className={Styles.templatesCarousel}>
        <div className={Styles.infiniteLoader}>
          <Carousel withControls={false} offset={carouselOffset}>
            <ShimmeringColor aspectRatio={width / height} width={itemWidth} height={itemHeight} />
            <ShimmeringColor aspectRatio={width / height} width={itemWidth} height={itemHeight} />
            <ShimmeringColor aspectRatio={width / height} width={itemWidth} height={itemHeight} />
            <ShimmeringColor aspectRatio={width / height} width={itemWidth} height={itemHeight} />
            <ShimmeringColor aspectRatio={width / height} width={itemWidth} height={itemHeight} />
            <ShimmeringColor aspectRatio={width / height} width={itemWidth} height={itemHeight} />
            <ShimmeringColor aspectRatio={width / height} width={itemWidth} height={itemHeight} />
            <ShimmeringColor aspectRatio={width / height} width={itemWidth} height={itemHeight} />
          </Carousel>
        </div>
      </div>
    </div>
  )
}

export const LoadingState = ({ width, height, itemWidth, itemHeight, categories = 3, carouselOffset }: Props) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <>
      {[...Array(categories)].map((_, i) => (
        <ShimmeringCategory
          key={i}
          width={width}
          height={height}
          itemWidth={itemWidth}
          itemHeight={itemHeight}
          carouselOffset={carouselOffset ?? (isMobile ? 20 : 35)}
        />
      ))}
    </>
  )
}
